var header_account_menu = (function( $ ) {

	var $menu,
		$header,
		anim_speed = 300;

	var init = function() {
		$header = $( '#header' );
		$menu   = $( '#account-header-menu' );
		
		if ( $menu.length > 0 ) {
			_setup_menu_toggle();
			_setup_logout();
		}
	};

	var _setup_logout = function() {
		$menu.find( '.multireg-logout' ).on( 'click', function( e ) {
			$.post( ScriptData.ajaxurl, 'action=logout',function(data) {
				jQuery.cookie('login_credentials', null);
				window.location.href = ScriptData.logout_redirect;
			});
			e.preventDefault();
		} );
	};

	var _setup_menu_toggle = function() {
		$header.find( '.header-account-toggle' ).click( function( e ) {
			e.preventDefault();
			_toggle_menu();
		} );

		$( '#content' ).on( 'click', function( e ) {
			if ( open && ! e.target.matches( '#account-header-menu, #account-header-menu *' ) ) {
				_close_menu();
			}
		} );
	};

	var _toggle_menu = function() {
		if ( $menu.hasClass( 'animating') ) {
			return
		}

		$menu.addClass('animating');

		if ( $menu.hasClass( 'open' ) ) {
			_close_menu();
		} else {
			_open_menu();
		}

		setTimeout( function() {
			$menu.removeClass( 'animating' )
		}, anim_speed)
	};

	var _open_menu = function() {
		$header.find( '.account-link' ).addClass( 'open' );

		$menu.removeClass( 'closed' );
		$menu.addClass( 'open' );
		$menu.slideDown( anim_speed );
	};

	var _close_menu = function() {
		$header.find( '.account-link' ).removeClass( 'open' );

		$menu.removeClass( 'open' );
		$menu.addClass( 'closed' );
		$menu.slideUp( anim_speed );
	};

	$( document ).ready( init );

	return {
		init: init
	}

})( jQuery );

module.exports = header_account_menu;